import React from "react";

const RadioButton = ({ text, name, checked, onChange, disabled, value }) => {
  return (
    <label className="radioButton">
      <input
        type="radio"
        name={name}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        value={value}
      />
      <span className="radioCheck"></span>
      {text && <span className="">{text}</span>}
    </label>
  );
};

export default RadioButton;
